export const DEFAULT_ANNUNCEMENT = {
  announcementText: 'Highlight promotions, sales, or updates here.',
  textCharCount: 0,
  redirectUrl: '',
  redirectionType: 'link',
  isOpenInNewTab: true,
  isVisible: true,
} as const;
